<template>
  <div id="dialogEditAdministrador">
    <v-dialog v-model="getEditAdministradorDialog" persistent max-width="400px">
      <v-card>
        <v-card-title> Editar Información de Administrador </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="getSelectedAdministradorEdit.usuario"
                  label="Usuario administrador"
                  required
                  outlined
                  dense
                  readonly
                  hint="No se puede cambiar"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="getSelectedAdministradorEdit.adminType"
                  label="Tipo de Administrador"
                  required
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="getSelectedAdministradorEdit.password"
                  label="Contraseña"
                  required
                  outlined
                  dense
                  hint="Dejar campo en blanco si no requiere cambiar la contraseña"
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="12" md="12">
                <v-switch
                  v-model="getSelectedAdministradorEdit.usuarioActivo"
                  :label="
                    getSelectedAdministradorEdit.usuarioActivo
                      ? 'Usuario Administrador Activo'
                      : 'Usuario Administrador Inactivo'
                  "
                  required
                  outlined
                  dense
                ></v-switch>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn color="blue darken-1" text @click="closeDialog">
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="updateDatosAdministrador()">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  computed: {
    ...mapGetters('admin', [
      'getEditAdministradorDialog',
      'getSelectedAdministradorEdit'
    ])
  },

  methods: {
    async updateDatosAdministrador() {
      console.log(this.getSelectedAdministradorEdit)
      let success = await this.fetchUpdateAdminInformation(
        this.getSelectedAdministradorEdit
      )
      if (success) {
        this.setNoChangeEdit(false)
        await this.fetchListaAdministradores()
        this.setEditAdministradorDialog(false)
      }
    },

    closeDialog() {
      this.setNoChangeEdit(true)
      this.setEditAdministradorDialog(false)
    },

    ...mapMutations('admin', ['setEditAdministradorDialog', 'setNoChangeEdit']),

    ...mapActions('admin', [
      'fetchUpdateAdminInformation',
      'fetchListaAdministradores'
    ])
  }
}
</script>

<style>
</style>